import { Outlet } from "react-router-dom";
import { SiteHeader, PlatformFooter } from "../../components/platform/PlatformChrome";

/**
 * Authenticated app shell. The header + footer are the shared PlatformChrome, so
 * the dashboard and the course learner surfaces (/courses…) carry the identical
 * RBAC-driven platform header. Page content renders in the Outlet between them.
 */
export default function DashboardLayout() {
  return (
    <>
      <SiteHeader />
      <main className="pt-24 md:pt-28 pb-20 min-h-[100svh]">
        <Outlet />
      </main>
      <PlatformFooter />
    </>
  );
}
